import React, { useState } from "react";
import { Div, Text, Row, Col, Button, Image } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import AnimateLink from "../common/AnimateLink";
import HomeCreatorModal from "../../modals/HomeCreatorModal";

const HomeCreatorsList = ({ content, showBrandApplication }) => {
  const [showCreator, setShowCreator] = useState(false);
  const [swiperIndex, setSwiperIndex] = useState(false);

  const showBrand = val => {
    setShowCreator(!val);
    showBrandApplication(val);
  };

  return (
    <Div className="home-creators-section">
      <WebsiteContainer>
        <CustomContainer>
          <Div className="creators-list">
            {content.map((creator, index) => {
              return (
                <Div
                  className="creator-card"
                  onClick={() => {
                    setShowCreator(true);
                    setSwiperIndex(index);
                  }}
                >
                  <Div
                    p={{ b: "100%" }}
                    bgImg={creator.pic}
                    bgSize="cover"
                    bgPos="center"
                  />
                  <Div
                    className="name-box"
                    p="1rem 0 1.5rem"
                    textAlign="center"
                  >
                    <Text tag="h3" className="name">
                      {creator.name}
                    </Text>
                    <Div className="followers">
                      {creator.instagramFollowers} Followers on IG
                    </Div>
                  </Div>
                </Div>
              );
            })}
          </Div>
        </CustomContainer>
      </WebsiteContainer>
      <HomeCreatorModal
        isOpen={showCreator}
        onClose={() => setShowCreator(false)}
        modalContent={content}
        swiperIndex={swiperIndex}
        showBrand={val => showBrand(val)}
      />
    </Div>
  );
};

export default HomeCreatorsList;
